import { memo, useMemo, useEffect, useCallback } from 'react'
import { Box, Divider, Flex, Heading } from '@chakra-ui/react'

import { getStringInPhraseFormat } from 'utils/transforms/string'
import RangerStartCalendar from './components/StartCalendar'
import RangerEndCalendar from './components/EndCalendar'
import useCalendar from './hook/useCalendar'
import { useCalendarFilters } from '../../contexts/CalendarFiltersManager/Provider'

function RangerCalendars() {
  const { dateFilterType, feedbackDateString, startDate, finalDate } = useCalendarFilters()

  const currentMonth = new Date().getMonth()

  const rangerStartCalendar = useCalendar(currentMonth - 1)
  const rangerEndCalendar = useCalendar()

  console.log('rangerStartCalendar', rangerStartCalendar)
  console.log('rangerEndCalendar', rangerEndCalendar)

  const daysOfTheWeek = useMemo(() => {
    return ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
  }, [])

  const goNextMonth = () => {
    rangerStartCalendar.nextMonth()
    rangerEndCalendar.nextMonth()
  }

  const goPreviousMonth = () => {
    rangerStartCalendar.previousMonth()
    rangerEndCalendar.previousMonth()
  }

  const getMonthFromStringDate = useCallback((stringDate: string) => {
    const splitedDate = stringDate.split('/')
    const month = Number(splitedDate[1])
    return month - 1
  }, [])

  const getYearFromStringDate = useCallback((stringDate: string) => {
    const splitedDate = stringDate.split('/')
    const year = Number(splitedDate[2])
    return year
  }, [])

  useEffect(() => {
    if (startDate) {
      const month = getMonthFromStringDate(startDate)
      const year = getYearFromStringDate(startDate)

      rangerStartCalendar.resetCalendar(month, year)

      if (month === 11) {
        rangerEndCalendar.resetCalendar(0, year + 1)
      } else {
        rangerEndCalendar.resetCalendar(month + 1, year)
      }
    }
  }, [startDate])

  useEffect(() => {
    if (finalDate) {
      const month = getMonthFromStringDate(finalDate)
      const year = getYearFromStringDate(finalDate)

      rangerEndCalendar.resetCalendar(month, year)

      if (month !== currentMonth - 1) {
        if (month === 0) {
          rangerStartCalendar.resetCalendar(11, year - 1)
        } else {
          rangerStartCalendar.resetCalendar(month - 1, year)
        }
      } else {
        rangerEndCalendar.resetCalendar(month + 1, year)
      }
    }
  }, [finalDate])

  return (
    <>
      <Box width="100%" my={2}>
        <Divider borderColor="borderColor" />
      </Box>

      <Heading color="primary" mb={2} textAlign="center" w={['300px', '300px', 'auto']}>
        {getStringInPhraseFormat(`${dateFilterType}${feedbackDateString}`)}
      </Heading>

      <Flex bg="light" justify="center" direction={{ base: 'column', md: 'row' }}>
        <RangerStartCalendar goPreviousMonth={goPreviousMonth} daysOfTheWeek={daysOfTheWeek} {...rangerStartCalendar} />

        <RangerEndCalendar daysOfTheWeek={daysOfTheWeek} goNextMonth={goNextMonth} {...rangerEndCalendar} />
      </Flex>
    </>
  )
}

export default memo(RangerCalendars)
